﻿import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {ActionButton} from '../../../UI/pageComponents';

import {getInsurancePurchaseUrlForAction} from '../../../State/actions';
import {getRelatedGroupsForInsurance} from '../../../DataHelpers/lfDataHelpers'; 

import {iconCode, mediaQuery, clearFix} from '../../../Style/cssHelpers';
import definitions from '../../../Style/LfStyleDefinitions';

class AnimalUpgradeCta extends React.Component {
    static get propTypes() {
        return {
            alignment: PropTypes.string,
            possession: PropTypes.object.isRequired
        }
    }

    insuranceTypeLabel(insurance) {
        switch (insurance.animalType) {
            case 'dog':
                return 'Hundförsäkring';
            case 'cat':
                return 'Kattförsäkring';
            case 'small-animal':
                return 'Smådjursförsäkring';
            default:
                return 'försäkring';
        }
    }

    render() {
        const possession = this.props.possession;
        const upgrades = this.props.data.insurancesByName[possession.insuranceName].possibleUpgrades
            .map(upgradeName => ({
                ...this.props.data.insurancesByName[upgradeName], 
                ...this.props.data.quotesByName[upgradeName]
            }));

        return (
            <Wrapper alignment={this.props.alignment}>
                <UpgradeHeading>
                    Uppgradera din {this.insuranceTypeLabel(possession)} för:
                </UpgradeHeading>

                {upgrades.map((upgrade, i) => {
                    if (!(possession.insuranceObjectId in this.props.animalPossessionQuotes)) {
                        return null; 
                    }

                    const upgradeQuote = this.props.animalPossessionQuotes[possession.insuranceObjectId][upgrade.insuranceName];
                    const upgradeUrl = this.props.getInsurancePurchaseUrlFor(
                        [upgrade.groupName, ...getRelatedGroupsForInsurance(upgrade.insuranceName)],
                        upgrade.insuranceName,
                        possession.possessionId
                    ); 

                    return (
                        <a 
                            href={upgradeUrl}
                            key={`upgrade-${upgrade.groupName}-${i}`}
                        >
                            <ActionButton>
                                +{upgradeQuote - possession.premium} kr/mån
                            </ActionButton>
                        </a>
                    );
                })}
            </Wrapper>
        );
    }
}

// state

const mapStateToProps = (state) => {
    return {
        data: state.startPageData,
        animalPossessionQuotes: state.startPageAnimalPossessionQuoteData
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getInsurancePurchaseUrlFor: (groupName, selection, possessionId) => dispatch(getInsurancePurchaseUrlForAction(groupName, selection, possessionId))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AnimalUpgradeCta);

// styles

const Wrapper = styled.div`
    display: block; 
    text-align: ${props => props.alignment ? props.alignment : 'center'}; 
    margin-bottom: 55px;

    ${mediaQuery.medium(`
        margin-bottom: 0px;
    `)}
    ${mediaQuery.xsmall(`
        max-width: none;
    `)}
    ${mediaQuery.xxsmall(`
        max-width: 88vw;
    `)}
`;

const UpgradeHeading = styled.h4`
    display: inline-block;
    margin-right: 40px;
    margin-bottom: 20px;
    font-size: 20px;
    color: white;
    ${mediaQuery.medium(`
        margin-top: 25px;
        width: 100%;
    `)}
    ${mediaQuery.small(`
        font-size: 16px;
        float: left;
        margin-bottom: 15px;
        margin-right: 0px;
        text-align: left;
    `)}
`;

